export default __webpack_public_path__ + "static/media/03-ART-(3-5).6b1c228c.jpg";